"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PSWRULE = PSWRULE;
exports.checkMax20000 = checkMax20000;
exports.checkMaxVal = checkMaxVal;
exports.isBtnOneToHundred = isBtnOneToHundred;
exports.isBtnOneToTen = isBtnOneToTen;
exports.isBtnZeroToHundred = isBtnZeroToHundred;
exports.isCheckPort = isCheckPort;
exports.isDecimal = isDecimal;
exports.isInteger = isInteger;
exports.isIntegerNotMust = isIntegerNotMust;
exports.isMore0 = isMore0;
exports.isOneToNinetyNine = isOneToNinetyNine;
exports.isPassword = isPassword;
exports.isPort = isPort;
exports.isZInteger = isZInteger;
exports.validatAlphabets = validatAlphabets;
exports.validateEMail = validateEMail;
exports.validateIP = validateIP;
exports.validateIdNo = validateIdNo;
exports.validateLowerCase = validateLowerCase;
exports.validatePhone = validatePhone;
exports.validatePhoneTwo = validatePhoneTwo;
exports.validateTelphone = validateTelphone;
exports.validateURL = validateURL;
exports.validateUpperCase = validateUpperCase;
exports.validatetoFixedNew = validatetoFixedNew;
require("core-js/modules/es6.regexp.replace");
var _typeof2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/es6.number.constructor");
/*是否合法IP地址*/
function validateIP(rule, value, callback) {
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]).(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]).(\d{1,2}|1\d\d|2[0-4]\d|25[0-5]).(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
    if (!reg.test(value) && value != '') {
      callback(new Error('请输入正确的IP地址'));
    } else {
      callback();
    }
  }
}

/* 是否手机号码或者固话*/
function validatePhoneTwo(rule, value, callback) {
  // const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
  var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if (!reg.test(value) && value != '') {
      callback(new Error('请输入正确的电话号码'));
    } else {
      callback();
    }
  }
}
/* 是否固话*/
function validateTelphone(rule, value, callback) {
  var reg = /0\d{2}-\d{7,8}/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if (!reg.test(value) && value != '') {
      callback(new Error('请输入正确的固话（格式：区号+号码,如010-1234567）'));
    } else {
      callback();
    }
  }
}
/* 是否手机号码*/
function validatePhone(rule, value, callback) {
  var reg = /^[1][3,4,5,7,8][0-9]{9}$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if (!reg.test(value) && value != '') {
      callback(new Error('请输入正确的电话号码'));
    } else {
      callback();
    }
  }
}
/* 是否身份证号码*/
function validateIdNo(rule, value, callback) {
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if (!reg.test(value) && value != '') {
      callback(new Error('请输入正确的身份证号码'));
    } else {
      callback();
    }
  }
}
/* 是否邮箱*/
function validateEMail(rule, value, callback) {
  var reg = /^([a-zA-Z0-9]+[-_.]?)+@[a-zA-Z0-9]+.[a-z]+$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的邮箱地址'));
    } else {
      callback();
    }
  }
}
/* 合法uri*/
function validateURL(rule, textval, callback) {
  var urlregex = /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62}))+$/;
  // return urlregex.test(textval);
  if (textval == '' || textval == undefined || textval == null) {
    callback();
  } else {
    if (!urlregex.test(textval)) {
      callback(new Error('请输入正确的链接'));
    } else {
      callback();
    }
  }
}

/*验证内容是否英文数字以及下划线*/
function isPassword(rule, value, callback) {
  var reg = /^[_a-zA-Z0-9]+$/;
  if (value == '' || value == undefined || value == null) {
    callback();
  } else {
    if (!reg.test(value)) {
      callback(new Error('密码仅由英文字母，数字以及下划线组成'));
    } else {
      callback();
    }
  }
}

/*自动检验数值的范围*/
function checkMax20000(rule, value, callback) {
  if (value == '' || value == undefined || value == null) {
    callback();
  } else if (!Number(value)) {
    callback(new Error('请输入[1,20000]之间的数字'));
  } else if (value < 1 || value > 20000) {
    callback(new Error('请输入[1,20000]之间的数字'));
  } else {
    callback();
  }
}

//验证数字输入框最大数值,32767
function checkMaxVal(rule, value, callback) {
  if (value < 0 || value > 32767) {
    callback(new Error('请输入[0,32767]之间的数字'));
  } else {
    callback();
  }
}
//验证是否1-99之间
function isOneToNinetyNine(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(function () {
    if (!Number(value)) {
      callback(new Error('请输入正整数'));
    } else {
      var re = /^[1-9][0-9]{0,1}$/;
      var rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入正整数，值为【1,99】'));
      } else {
        callback();
      }
    }
  }, 0);
}

// 验证是否正整数
function isInteger(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(function () {
    if (!Number(value)) {
      callback(new Error('请输入正整数'));
    } else {
      var re = /^[0-9]*[1-9][0-9]*$/;
      var rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
  }, 0);
}
// 验证是否大于等于0的整数
function isMore0(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(function () {
    var re = /^(0|[1-9][0-9]*|)$/;
    var rsCheck = re.test(value);
    if (!rsCheck) {
      callback(new Error('请输入0或正整数'));
    } else {
      callback();
    }
  }, 0);
}

// 验证是否整数
function isZInteger(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(function () {
    if (!Number(value)) {
      callback(new Error('请输入-1或者正整数'));
    } else {
      var re = /^(-1|[1-9][0-9]*|)$/;
      var rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入-1或者正整数'));
      } else {
        callback();
      }
    }
  }, 0);
}

// 验证是否整数,非必填
function isIntegerNotMust(rule, value, callback) {
  if (!value) {
    callback();
  }
  setTimeout(function () {
    if (!Number(value)) {
      callback(new Error('请输入正整数'));
    } else {
      var re = /^[0-9]*[1-9][0-9]*$/;
      var rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
  }, 1000);
}

// 验证是否是[0-1]的小数
function isDecimal(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(function () {
    if (!Number(value)) {
      callback(new Error('请输入[0,1]之间的数字'));
    } else {
      if (value < 0 || value > 1) {
        callback(new Error('请输入[0,1]之间的数字'));
      } else {
        callback();
      }
    }
  }, 100);
}

// 验证是否是[1-10]的小数,即不可以等于0
function isBtnOneToTen(rule, value, callback) {
  if (typeof value == 'undefined') {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(function () {
    if (!Number(value)) {
      callback(new Error('请输入正整数，值为[1,10]'));
    } else {
      if (!(value == '1' || value == '2' || value == '3' || value == '4' || value == '5' || value == '6' || value == '7' || value == '8' || value == '9' || value == '10')) {
        callback(new Error('请输入正整数，值为[1,10]'));
      } else {
        callback();
      }
    }
  }, 100);
}
// 验证是否是[1-100]的小数,即不可以等于0
function isBtnOneToHundred(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(function () {
    if (!Number(value)) {
      callback(new Error('请输入整数，值为[1,100]'));
    } else {
      if (value < 1 || value > 100) {
        callback(new Error('请输入整数，值为[1,100]'));
      } else {
        callback();
      }
    }
  }, 100);
}
// 验证是否是[0-100]的小数
function isBtnZeroToHundred(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(function () {
    if (!Number(value)) {
      callback(new Error('请输入[1,100]之间的数字'));
    } else {
      if (value < 0 || value > 100) {
        callback(new Error('请输入[1,100]之间的数字'));
      } else {
        callback();
      }
    }
  }, 100);
}

// 验证端口是否在[0,65535]之间
function isPort(rule, value, callback) {
  if (!value) {
    return callback(new Error('输入不可以为空'));
  }
  setTimeout(function () {
    if (value == '' || (0, _typeof2.default)(value) == undefined) {
      callback(new Error('请输入端口值'));
    } else {
      var re = /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
      var rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入在[0-65535]之间的端口值'));
      } else {
        callback();
      }
    }
  }, 100);
}
// 验证端口是否在[0,65535]之间，非必填,isMust表示是否必填
function isCheckPort(rule, value, callback) {
  if (!value) {
    callback();
  }
  setTimeout(function () {
    if (value == '' || (0, _typeof2.default)(value) == undefined) {
      //callback(new Error('请输入端口值'));
    } else {
      var re = /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
      var rsCheck = re.test(value);
      if (!rsCheck) {
        callback(new Error('请输入在[0-65535]之间的端口值'));
      } else {
        callback();
      }
    }
  }, 100);
}

/* 小写字母*/
function validateLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}
/*保留2为小数*/
function validatetoFixedNew(str) {
  return str;
}
/* 验证key*/
// export function validateKey(str) {
//     var reg = /^[a-z_\-:]+$/;
//     return reg.test(str);
// }

/* 大写字母*/
function validateUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
function validatAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}
/**
 * 描述 登陆密码验证规则
 * @author kkdy
 * @date 2022-03-31
 * @param {any} rule
 * @param {any} value
 * @param {any} callback
 * @returns {any}
 */
function PSWRULE(rule, value, callback) {
  setTimeout(function () {
    var re = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,32}$/;
    console.log(value);
    var rsCheck = re.test(value.replace(/\s+/g, ""));
    if (!rsCheck) {
      callback(new Error('密码由8-32位字母，数字，特殊字符组成'));
    } else {
      callback();
    }
  }, 100);
}